<div
  class="w-full flex align-items-center justify-content-center"
  [style.--page-section-background-color]="pageSectionBackground()"
  [class.section-with-background-color]="!!pageSectionBackground()">
  <div class="page-section page-section-x-padded">
    <div
      class="card-container flex flex-column"
      [class]="isPresentationType() ? 'small-container' : 'large-container mx-auto'">
      @if (headline() || subheading()) {
        <div class="card-container-headings flex flex-column">
          @if (headline(); as headlineText) {
            <h2 class="my-0">{{ headlineText }}</h2>
          }
          @if (subheading(); as subheadingText) {
            <h3 class="my-0">{{ subheadingText }}</h3>
          }
        </div>
      }
      @switch (presentation()) {
        @case (ContainerCardPresentation.GENERAL) {
          <ppg-general-presentation-component [cards]="cards()" />
        }
        @case (ContainerCardPresentation.LIST) {
          <ppg-list-presentation-component class="flex" [cards]="cards()" />
        }
        @case (ContainerCardPresentation.INFORMATION) {
          <ppg-information-presentation-component class="flex justify-content-center" [cards]="cards()" />
        }
        @case (ContainerCardPresentation.INFORMATION_LARGE) {
          <ppg-large-information-presentation-component class="flex justify-content-center" [cards]="cards()" />
        }
        @case (ContainerCardPresentation.TITLE) {
          <ppg-title-presentation-component class="flex justify-content-center" [cards]="cards()" />
        }
        @case (ContainerCardPresentation.MEDIA) {
          <ppg-media-presentation-component class="flex justify-content-center" [cards]="cards()" />
        }
      }
      @if (cta()) {
        <p-button
          class="container-card-button flex justify-content-center"
          iconPos="right"
          [outlined]="true"
          [label]="cta()?.content?.text"
          icon="pi pi-arrow-up-right arrow-up-right p-button-icon p-button-icon-right"
          (onClick)="navigateTo()"></p-button>
      }
    </div>
  </div>
</div>
